<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <el-form-item>
        <el-input placeholder="请输入用户名/真是姓名" prefix-icon="el-icon-search" type="input" clearable
          v-model="searchModel.obj"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="default" icon="el-icon-search" @click="getUserList"></el-button>
      </el-form-item>
    </el-form>
    <el-table border stripe :data="userList">
      <el-table-column type="index" label="序号" width="80" align="center">
        <template slot-scope="scope">{{(scope.$index+1)+((searchModel.pageNo-1)*searchModel.pageSize)}}</template>
      </el-table-column>
      <el-table-column label="用户名" prop="userName" align="center">
      </el-table-column>
      <el-table-column label="头像" prop="image" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.image?scope.row.image:'/static/img/common/zwtp.png'" class="table_image"
            onerror="this.src='/static/img/common/zwtp.png'">
        </template>
      </el-table-column>
      <el-table-column label="电话" prop="phone" align="center">
      </el-table-column>
      <el-table-column label="邮箱" prop="email" align="center">
      </el-table-column>
      <el-table-column label="是否启用" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-text="是" inactive-text="否" :active-value="0" :inactive-value="1"
            @change="changeStatus(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="editUser(scope.row)">编辑</el-button>
          <el-button type="text" @click="deleteUser(scope.row.userId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-panel__footer">
      <el-pagination :current-page.sync='searchModel.pageNo' :page-size='searchModel.pageSize'
        layout='prev, pager, next, jumper' :total='total' @current-change='getUserList'>
      </el-pagination>
    </div>
    <el-dialog :title="userTitle" :visible.sync="userdialogVisable" width="40%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th>用户名</th>
            <td>
              <el-input v-model="userParam.userName" placeholder="请输入用户名"></el-input>
            </td>
          </tr>
          <tr>
            <th>密码</th>
            <td>
              <el-input v-model="userParam.password" placeholder="请输入密码" type='password'></el-input>
            </td>
          </tr>
          <tr>
            <th>手机号</th>
            <td>
              <el-input v-model="userParam.phone" placeholder="请输入手机号码"></el-input>
            </td>
          </tr>
          <tr>
            <th>备用手机号</th>
            <td>
              <el-input v-model="userParam.phonesec" placeholder="请输入备用手机号"></el-input>
            </td>
          </tr>
          <tr>
            <th>邮箱</th>
            <td>
              <el-input v-model="userParam.email" placeholder="请输入邮箱" type="email"></el-input>
            </td>
          </tr>
          <tr>
            <th>地址</th>
            <td>
              <el-input v-model="userParam.address" placeholder="请输入地址"></el-input>
            </td>
          </tr>
          <tr>
            <th>头像</th>
            <td>
              <el-upload class="avatar-uploader" action="/file/upload" :show-file-list="false"
                :on-success="uploadSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click="userdialogVisable = false">取 消</el-button>
        <el-button type="primary" @click="adduser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as userCenterApi from '@/api/userCenter';
export default {
  data() {
    return {
      userParam: {},
      userTitle: '',
      imageUrl: '',
      userdialogVisable: false,
      userList: [],
      total: 0,
      searchModel: {
        pageNo: 1,
        pageSize: 15
      }
    };
  },
  methods: {
    deleteUser(id) {
      this.$confirm('是否删除该用户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userCenterApi.deletuser({ userId: id }).then(res => {
            this.getUserList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    editUser(row) {
      this.userTitle = '编辑用户信息';
      this.userParam = row;
      this.imageUrl = row.image;
      this.userdialogVisable = true;
    },
    openDialog() {
      this.userdialogVisable = true;
      this.addMemberTitle = '新增用户';
      this.userParam = {
        // sex 0 男 1 女
        sex: 0
      };
      this.imageUrl = '';
    },
    adduser() {
      if (!this.userParam.userId) {
        userCenterApi.adduser(this.userParam).then(res => {
          this.userParam = {};
          this.imageUrl = '';
          this.userdialogVisable = false;
          this.getUserList();
        });
      } else {
        userCenterApi.updateUser(this.userParam).then(res => {
          this.userParam = {};
          this.imageUrl = '';
          this.userdialogVisable = false;
          this.getUserList();
        });
      }
    },
    uploadSuccess(res, file, fileList) {
      this.userParam.image = res.url;
      this.imageUrl = res.url;
    },
    changeStatus(row) {
      let confirmText = '';
      if (row.status === 1) {
        confirmText = '确认停用该账户？';
      } else {
        confirmText = '确认启用该账户？';
      }
      this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userCenterApi
            .changeStatus({ userId: row.userId, status: row.status })
            .then(res => {
              if (res.result.code !== 1) {
                this.getUserList();
              } else {
                if (row === 1) {
                  row.status = 0;
                } else {
                  row.status = 1;
                }
                this.$notify({
                  title: '警告',
                  message: res.result.message,
                  type: 'warning'
                });
              }
            });
        })
        .catch(() => {
          if (row === 1) {
            row.status = 0;
          } else {
            row.status = 1;
          }
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
    },
    getUserList() {
      userCenterApi.getUserList(this.searchModel).then(res => {
        this.userList = res.data.records;
        this.total = res.data.total;
      });
    }
  },
  created() {
    this.getUserList();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/userCenter/user.vue